import * as React from 'react';

import Icon from '@ant-design/icons/lib/components/Icon';

const IPen = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
            <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.57741 19.3781L4.85164 14.2812H0L0.477837 12.3698H5.32948L6.62824 7.17479H1.7766L2.25444 5.26344H7.10608L8.38031 0.166504H10.2671L8.9929 5.26344H14.2615L15.5358 0.166504H17.4226L16.1484 5.26344H21L20.5222 7.17479H15.6705L14.3718 12.3698H19.2234L18.7456 14.2812H13.8939L12.6197 19.3781H10.7329L12.0071 14.2812H6.73846L5.46423 19.3781H3.57741ZM7.2163 12.3698H12.4849L13.7837 7.17479H8.51506L7.2163 12.3698Z"
              fill="#AEA9B1"
            />
          </svg>

        );
      }}
      {...props}
    />
  );
};

export default IPen;
